import { EventEmitter, Injectable } from '@angular/core';
import { isNotNullable, Product } from '@spartacus/core';
import { BehaviorSubject, filter, Observable } from 'rxjs';
import { QuotesAdapter } from './quotes.adapter';

@Injectable({
  providedIn: 'root',
})
export class QuotesService {
  protected newProduct$ = new BehaviorSubject<Product | undefined>(undefined);
  clearBasicSearch$ = new EventEmitter();
  clearFileList$ = new EventEmitter();
  resetGeneralInformation$ = new EventEmitter();

  maxTextLength = 2000;
  maxEndCustomerLength = 40;
  maxCompetitorLength = 40;

  constructor(private quotesAdapter: QuotesAdapter) {}

  generateID(length: number = 10): string {
    const timestamp = Date.now().toString();
    let randomNumbers = '';

    for (let i = 0; i < length - timestamp.length; i++) {
      randomNumbers += Math.floor(Math.random() * 10).toString();
    }

    return timestamp + randomNumbers;
  }

  addProduct(product: Product) {
    this.newProduct$.next(product);
  }

  getNewProduct(): Observable<Product> {
    return this.newProduct$.asObservable().pipe(filter(product => isNotNullable(product)));
  }

  postQuote(quote: any) {
    return this.quotesAdapter.postQuote(quote);
  }

  getFrequency() {
    return this.quotesAdapter.getFrequency();
  }

  getQuoteHistory(from: string, to: string) {
    return this.quotesAdapter.getUserQuoteHistory(from, to);
  }

  getQuoteDetails(uid: string) {
    return this.quotesAdapter.getUserQuoteDetails(uid);
  }

  addToCartQuoteLine(quoteUid: string, code: string, quantity: number) {
    return this.quotesAdapter.addToCartQuoteLine(quoteUid, code, quantity);
  }

  exportToCSV(fromDate: string, toDate: string) {
    return this.quotesAdapter.exportToCSV(fromDate, toDate);
  }
}
